/**
 * 一个空的 Vue 实例作为事件总线，用于非父子关系的两个组件之间通信。
 */
import Vue from 'vue';
let Bus = new Vue();
export default Bus
